module.exports = __webpack_public_path__ + "img/Confirm Message.1189132e.svg";